export const initContactUsLabelForm = () => {
    const module = document.querySelector('.gg-contact-us-label-form');

    if (!module) {
        return;
    }

    const toggleButton = module.querySelector('.gg-contact-us-label-form__toggle .wp-block-button__link');

    const toggleModule = () => {
        module.classList.toggle('active');
    };

    toggleButton?.addEventListener('click', toggleModule);

    toggleButton?.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
            toggleModule();
        }
    });

    window.addEventListener('message', (event) => {
        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
            const targetForm = module.querySelector(`.hs-form-${event.data.id}`);

            if (targetForm === null) {
                return;
            }

            module.classList.add('form-ready');
        }
    });
};
